/* ==========================================================================
   Homellence V10 · Feinschliff (Cowork, 28.09.2026)
   1. P3  Groessentabelle hinter der vorhandenen Ueberschrift
   2. P5  Faltmoment: Karten im Laufband zeigen den Faltclip
   3. 3D-C Grundriss als Modellhaus (Waende, drehen und kippen)
   Keine neuen Texte: Ueberschrift und Clips kommen aus dem Theme.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------------
     1 · Groessentabelle: die Ueberschrift wird zum Schalter
     --------------------------------------------------------------------- */
  function initSizeTables() {
    document.querySelectorAll('.hl-size-table').forEach(function (box, i) {
      if (box.classList.contains('is-collapsible')) return;
      var head = box.querySelector('.hl-eyebrow');
      if (!head) return;
      var body = document.createElement('div');
      body.className = 'hl-size-table__body';
      body.id = 'hl-size-table-' + i;
      var node = head.nextSibling;
      while (node) {
        var next = node.nextSibling;
        body.appendChild(node);
        node = next;
      }
      box.appendChild(body);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hl-size-table__toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', body.id);
      while (head.firstChild) btn.appendChild(head.firstChild);
      btn.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 4.5 6 8.5 10 4.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      head.appendChild(btn);
      body.hidden = true;
      box.classList.add('is-collapsible');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        body.hidden = open;
      });
    });
  }

  /* ---------------------------------------------------------------------
     2 · Faltmoment auf den Karten
     Quelle: die Clips aus dem Abschnitt „In Sekunden“ auf derselben Seite,
     zugeordnet ueber den Pfad der Produktseite.
     Maus: beim Ueberfahren. Touch: einmal, wenn die Karte ganz im Bild ist,
     danach bleibt das letzte Bild (gefaltet) stehen.
     --------------------------------------------------------------------- */
  function initFoldCards() {
    if (reduce) return;
    var map = {};
    document.querySelectorAll('.hl-fold__item').forEach(function (item) {
      var a = item.querySelector('a.hl-fold__link');
      var v = item.querySelector('video[data-src]');
      if (!a || !v) return;
      try { map[new URL(a.href, location.href).pathname] = { src: v.getAttribute('data-src'), poster: v.getAttribute('poster') || '' }; } catch (e) {}
    });
    if (!Object.keys(map).length) return;

    var cards = [];
    document.querySelectorAll('.hl-lb-card').forEach(function (card) {
      if (card.__hlFold) return;
      var link = card.querySelector('.hl-lb-card__link');
      var stage = card.querySelector('.hl-lb-card__stage');
      if (!link || !stage) return;
      var path;
      try { path = new URL(link.href, location.href).pathname; } catch (e) { return; }
      var clip = map[path];
      if (!clip) return;
      card.__hlFold = true;
      var vid = document.createElement('video');
      vid.className = 'hl-lb-card__fold';
      vid.muted = true;
      vid.playsInline = true;
      vid.setAttribute('muted', '');
      vid.setAttribute('playsinline', '');
      vid.setAttribute('preload', 'none');
      vid.setAttribute('aria-hidden', 'true');
      if (clip.poster) vid.setAttribute('poster', clip.poster);
      stage.appendChild(vid);
      var entry = { card: card, vid: vid, src: clip.src, played: false };
      cards.push(entry);

      if (finePointer) {
        vid.loop = true;
        link.addEventListener('pointerenter', function () {
          if (!vid.getAttribute('src')) vid.setAttribute('src', entry.src);
          vid.currentTime = 0;
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add('is-folding');
        });
        link.addEventListener('pointerleave', function () {
          card.classList.remove('is-folding');
          vid.pause();
        });
      }
    });

    if (finePointer || !cards.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.intersectionRatio < 0.9) return;
        var item = cards.filter(function (c) { return c.card === en.target; })[0];
        if (!item || item.played) return;
        item.played = true;
        io.unobserve(en.target);
        item.vid.setAttribute('src', item.src);
        item.card.classList.add('is-folding');
        var p = item.vid.play();
        if (p && p.catch) p.catch(function () { item.card.classList.remove('is-folding'); });
      });
    }, { threshold: [0.9] });
    cards.forEach(function (c) { io.observe(c.card); });
  }

  /* ---------------------------------------------------------------------
     3 · Puppenhaus v2 (28.09.2026)
     Echte Waende aus den Wandlinien der Zeichnung (data-hl-walls), mit
     Deckel, Sockelplatte und Bodenschatten. Kamera in zwei Achsen:
     waagerecht ziehen dreht (Z), senkrecht ziehen kippt (X, nur Maus).
     Beim ersten Erscheinen richtet sich das Haus auf, danach folgt es
     dem Zeiger leicht und dreht sich beim Scrollen ein wenig mit.
     Raster 520 x 440 aus snippets/hl-plan-geometry.
     --------------------------------------------------------------------- */
  var ROOMS = {
    bath: [[10, 10, 190, 170]],
    bed: [[10, 180, 190, 120]],
    kitchen: [[200, 10, 310, 140]],
    living: [[290, 150, 220, 280]],
    hall: [[200, 150, 90, 280], [10, 300, 190, 130]]
  };
  var PLAN_W = 520, PLAN_H = 440;
  var WALL_H = 30, WALL_T = 6, SLAB = 14;
  var RX0 = 52, RZ0 = -26;          /* Startansicht */
  var RX_MIN = 34, RX_MAX = 66;     /* Kippen */
  var RZ_MIN = -58, RZ_MAX = 14;    /* Drehen */

  function roomAt(x, y) {
    var hit = null;
    Object.keys(ROOMS).forEach(function (k) {
      ROOMS[k].forEach(function (r) {
        if (x >= r[0] && x <= r[0] + r[2] && y >= r[1] && y <= r[1] + r[3]) hit = k;
      });
    });
    return hit;
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function soft(v, a, b) {
    if (v < a) return a - (a - v) * 0.3;
    if (v > b) return b + (v - b) * 0.3;
    return v;
  }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  function face(cls, css) { return '<span class="hl-dh__f ' + cls + '" style="' + css + '"></span>'; }

  function buildWalls(svg) {
    var g = svg && svg.querySelector('[data-hl-walls]');
    var raw = g ? g.getAttribute('data-hl-walls') : '';
    var H = WALL_H + 'px', T = WALL_T / 2;
    var html = '';
    raw.split(';').forEach(function (seg) {
      var n = seg.split(',').map(parseFloat);
      if (n.length !== 4 || n.some(isNaN)) return;
      var x1 = Math.min(n[0], n[2]), x2 = Math.max(n[0], n[2]);
      var y1 = Math.min(n[1], n[3]), y2 = Math.max(n[1], n[3]);
      var l = x1 - T, t = y1 - T, w = x2 - x1 + WALL_T, h = y2 - y1 + WALL_T;
      var horiz = (y1 === y2);
      html += '<div class="hl-dh__w" style="left:' + l + 'px;top:' + t + 'px;width:' + w + 'px;height:' + h + 'px">' +
        /* Nord / Sued (lange Seiten waagerechter Waende, Enden senkrechter) */
        face('hl-dh__f--n' + (horiz ? '' : ' hl-dh__f--end'), 'left:0;top:0;width:100%;height:' + H + ';transform:rotateX(90deg)') +
        face('hl-dh__f--s' + (horiz ? '' : ' hl-dh__f--end'), 'left:0;top:100%;width:100%;height:' + H + ';transform:rotateX(90deg)') +
        /* West / Ost */
        face('hl-dh__f--w' + (horiz ? ' hl-dh__f--end' : ''), 'left:0;top:0;width:' + H + ';height:100%;transform:rotateY(-90deg)') +
        face('hl-dh__f--e' + (horiz ? ' hl-dh__f--end' : ''), 'left:100%;top:0;width:' + H + ';height:100%;transform:rotateY(-90deg)') +
        face('hl-dh__f--cap', 'inset:0;transform:translateZ(' + H + ')') +
        '</div>';
    });
    return html;
  }

  function initDollhouse() {
    var section = document.querySelector('.hl-floorplan');
    if (!section) return;
    var story = section.querySelector('.hl-story-plan');
    var plate = section.querySelector('.hl-story-plan__plate');
    var stageEl = section.querySelector('.hl-story-plan__stage');
    if (!plate || !stageEl || plate.querySelector('.hl-dh')) return;
    if (!(window.CSS && CSS.supports && CSS.supports('transform-style', 'preserve-3d'))) return;

    /* Sockel, Bodenschatten, Waende */
    var base = document.createElement('div');
    base.className = 'hl-dh hl-dh--base';
    base.setAttribute('aria-hidden', 'true');
    var S = SLAB + 'px';
    base.innerHTML =
      '<span class="hl-dh__ground" style="transform:translateZ(-' + (SLAB + 1) + 'px)"></span>' +
      face('hl-dh__slab hl-dh__slab--n', 'left:0;top:0;width:100%;height:' + S + ';transform:rotateX(-90deg)') +
      face('hl-dh__slab hl-dh__slab--s', 'left:0;top:100%;width:100%;height:' + S + ';transform:rotateX(-90deg)') +
      face('hl-dh__slab hl-dh__slab--w', 'left:0;top:0;width:' + S + ';height:100%;transform:rotateY(90deg)') +
      face('hl-dh__slab hl-dh__slab--e', 'left:100%;top:0;width:' + S + ';height:100%;transform:rotateY(90deg)');
    plate.insertBefore(base, plate.firstChild);

    var walls = document.createElement('div');
    walls.className = 'hl-dh hl-dh--walls';
    walls.setAttribute('aria-hidden', 'true');
    walls.innerHTML = buildWalls(plate.querySelector('svg'));
    var firstSpot = plate.querySelector('.hl-story-plan__spot');
    plate.insertBefore(walls, firstSpot || null);
    /* Raumnamen: dieselben Woerter wie in der Zeichnung, als Schilder
       ueber den Waenden, damit keine Wand sie verdeckt. */
    var tags = document.createElement('div');
    tags.className = 'hl-dh hl-dh--tags';
    tags.setAttribute('aria-hidden', 'true');
    Array.prototype.forEach.call(plate.querySelectorAll('svg .hl-story-plan__label'), function (t) {
      var bb;
      try { bb = t.getBBox(); } catch (err) { return; }
      if (!bb || !bb.width) return;
      var d = document.createElement('span');
      d.className = 'hl-dh__tag' + (t.classList.contains('hl-story-plan__label--empty') ? ' hl-dh__tag--empty' : '');
      d.textContent = t.textContent;
      d.style.left = ((bb.x + bb.width / 2) / PLAN_W * 100).toFixed(3) + '%';
      d.style.top = ((bb.y + bb.height / 2) / PLAN_H * 100).toFixed(3) + '%';
      tags.appendChild(d);
    });
    plate.insertBefore(tags, firstSpot || null);
    section.classList.add('hl-dh-on');

    /* Ziffern kennen ihren Raum ueber ihre Rasterposition */
    var spots = Array.prototype.slice.call(plate.querySelectorAll('.hl-story-plan__spot'));
    var spotRoom = spots.map(function (s) {
      return roomAt(parseFloat(s.getAttribute('data-hl-x-after')), parseFloat(s.getAttribute('data-hl-y-after')));
    });
    var current = null;
    function lift(key) {
      if (key === current) return;
      current = key;
      spots.forEach(function (s, i) { s.classList.toggle('is-up', key !== null && spotRoom[i] === key); });
    }
    plate.querySelectorAll('.hl-story-plan__room-link').forEach(function (a) {
      var room = a.querySelector('[class*="hl-story-plan__room--"]');
      var m = room && (room.getAttribute('class') || '').match(/hl-story-plan__room--([a-z]+)/);
      var key = m ? m[1] : null;
      if (!key) return;
      a.addEventListener('pointerenter', function () { lift(key); });
      a.addEventListener('focus', function () { lift(key); });
    });
    spots.forEach(function (s, i) {
      var btn = s.querySelector('button') || s;
      btn.addEventListener('pointerenter', function () { lift(spotRoom[i]); });
      btn.addEventListener('focus', function () { lift(spotRoom[i]); });
    });

    /* ---- Kamera ---------------------------------------------------- */
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var baseRx = RX0, baseRz = RZ0;     /* vom Nutzer gezogen */
    var intro = reduce ? 1 : 0;         /* 0 = flach, 1 = aufgerichtet */
    var parX = 0, parY = 0, tParX = 0, tParY = 0; /* Zeiger-Neigung */
    var scrollOff = 0;
    var velZ = 0, velX = 0;
    var down = false, dragging = false, startX = 0, startY = 0, lastX = 0, lastY = 0, lastT = 0, pid = null, isMouse = false;
    var raf = 0, visible = false;

    function fitScale() {
      var fit = parseFloat(getComputedStyle(story || plate).getPropertyValue('--hl-story-fit')) || 1;
      var need = 681 * 0.8 * fit;     /* groesste Breite der gedrehten Platte */
      var k = Math.min(1, (stageEl.clientWidth - 8) / need);
      plate.style.setProperty('--hl-dh-k', Math.max(0.6, k).toFixed(3));
    }

    function place() {
      var e = easeOut(intro);
      var rx = 14 + (baseRx - 14) * e + parY;
      var rz = baseRz * e + (scrollOff + parX) * e;
      var grow = clamp((intro - 0.2) / 0.8, 0, 1);
      plate.style.setProperty('--hl-dh-rx', rx.toFixed(2) + 'deg');
      plate.style.setProperty('--hl-dh-rz', rz.toFixed(2) + 'deg');
      plate.style.setProperty('--hl-dh-g', Math.max(0.001, easeOut(grow)).toFixed(3));
    }

    var introStart = 0;
    function tick(now) {
      raf = 0;
      var more = false;
      if (intro < 1 && introStart) {
        intro = clamp((now - introStart) / 1600, 0, 1);
        more = intro < 1;
      }
      /* Nachlauf nach dem Ziehen */
      if (!dragging && (Math.abs(velZ) > 0.02 || Math.abs(velX) > 0.02)) {
        baseRz = soft(baseRz + velZ, RZ_MIN, RZ_MAX);
        baseRx = soft(baseRx + velX, RX_MIN, RX_MAX);
        velZ *= 0.92; velX *= 0.92;
        more = true;
      } else if (!dragging) {
        /* weich zurueck in den erlaubten Bereich */
        var tz = clamp(baseRz, RZ_MIN, RZ_MAX), tx = clamp(baseRx, RX_MIN, RX_MAX);
        if (Math.abs(tz - baseRz) > 0.05 || Math.abs(tx - baseRx) > 0.05) {
          baseRz += (tz - baseRz) * 0.18; baseRx += (tx - baseRx) * 0.18; more = true;
        }
      }
      /* Feder fuer die Zeiger-Neigung */
      var dx = tParX - parX, dy = tParY - parY;
      if (Math.abs(dx) > 0.01 || Math.abs(dy) > 0.01) {
        parX += dx * 0.08; parY += dy * 0.08; more = true;
      }
      place();
      if (more) kick();
    }
    function kick() { if (!raf) raf = requestAnimationFrame(tick); }

    fitScale();
    place();
    window.addEventListener('resize', fitScale, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(fitScale).observe(stageEl);
    /* hl-story-plan.js setzt --hl-story-fit erst nach dem ersten Bild */
    if (story && 'MutationObserver' in window) new MutationObserver(fitScale).observe(story, { attributes: true, attributeFilter: ['style'] });

    /* Aufrichten beim ersten Erscheinen */
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visible = en.isIntersecting;
          if (en.isIntersecting && en.intersectionRatio >= 0.35 && !introStart) {
            introStart = performance.now();
            kick();
          }
          if (en.isIntersecting) onScroll();
        });
      }, { threshold: [0, 0.35] });
      io.observe(stageEl);
    } else {
      intro = 1;
      place();
    }

    /* Beim Scrollen dreht sich das Haus leicht mit (+/- 7 Grad) */
    function onScroll() {
      if (reduce || !visible) return;
      var r = stageEl.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      scrollOff = (p - 0.5) * -14;
      kick();
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* Zeiger-Neigung (nur Maus) */
    if (fine && !reduce) {
      stageEl.addEventListener('pointermove', function (e) {
        if (down) return;
        var r = stageEl.getBoundingClientRect();
        tParX = ((e.clientX - r.left) / r.width - 0.5) * 8;
        tParY = ((e.clientY - r.top) / r.height - 0.5) * -6;
        kick();
      });
      stageEl.addEventListener('pointerleave', function () { tParX = 0; tParY = 0; kick(); });
    }
    stageEl.addEventListener('pointerleave', function () { if (!dragging) lift(null); });

    /* Ziehen: waagerecht dreht, senkrecht kippt (Maus). Am Handy scrollt
       senkrecht die Seite. */
    stageEl.classList.add('is-dh');
    stageEl.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      down = true;
      isMouse = e.pointerType === 'mouse' || e.pointerType === 'pen';
      startX = lastX = e.clientX;
      startY = lastY = e.clientY;
      lastT = performance.now();
      velZ = velX = 0;
      pid = e.pointerId;
      if (intro < 1) { intro = 1; introStart = introStart || 1; }
    });
    stageEl.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (!dragging) {
        var mx = Math.abs(e.clientX - startX), my = Math.abs(e.clientY - startY);
        if (mx < 6 && (!isMouse || my < 6)) return;
        if (!isMouse && my > mx) { down = false; return; }  /* Seite scrollt */
        dragging = true;
        stageEl.classList.add('is-dragging');
        try { stageEl.setPointerCapture(pid); } catch (err) {}
      }
      var now = performance.now();
      var dt = Math.max(8, now - lastT);
      var dz = (e.clientX - lastX) * 0.35;
      var dx = isMouse ? (e.clientY - lastY) * -0.25 : 0;
      baseRz = soft(baseRz + dz, RZ_MIN, RZ_MAX);
      baseRx = soft(baseRx + dx, RX_MIN, RX_MAX);
      velZ = dz / dt * 16; velX = dx / dt * 16;
      lastX = e.clientX; lastY = e.clientY; lastT = now;
      place();
    });
    function end() {
      if (!down) return;
      down = false;
      if (!dragging) return;
      var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      stageEl.addEventListener('click', stop, { capture: true, once: true });
      setTimeout(function () { stageEl.removeEventListener('click', stop, true); }, 80);
      setTimeout(function () { dragging = false; stageEl.classList.remove('is-dragging'); kick(); }, 0);
      if (reduce) { velZ = velX = 0; baseRz = clamp(baseRz, RZ_MIN, RZ_MAX); baseRx = clamp(baseRx, RX_MIN, RX_MAX); place(); }
    }
    stageEl.addEventListener('pointerup', end);
    stageEl.addEventListener('pointercancel', end);
    /* Doppelklick: zurueck in die Startansicht */
    stageEl.addEventListener('dblclick', function () { baseRx = RX0; baseRz = RZ0; velZ = velX = 0; kick(); });
  }

  function boot() {
    initSizeTables();
    initFoldCards();
    initDollhouse();
  }
  /* Nach DOMContentLoaded: dann haben auch die Skripte der Abschnitte
     (Laufband, Grundriss) ihre Karten und Ziffern schon gebaut. */
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
